import { render, staticRenderFns } from "./FormaPgto.vue?vue&type=template&id=5bcf221e&scoped=true"
import script from "./FormaPgto.vue?vue&type=script&lang=js"
export * from "./FormaPgto.vue?vue&type=script&lang=js"
import style0 from "./FormaPgto.vue?vue&type=style&index=0&id=5bcf221e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf221e",
  null
  
)

export default component.exports